import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import NotesCard from '~/components/notesCard/notesCard';
import LotDetailCard from '~/components/lotDetailCard/lotDetailCard';
import LotSummaryCard from '~/components/lotSummaryCard/lotSummaryCard';
import LotTransfersCard from '~/components/lotTransfersCard/lotTransfersCard';
import ConsolidatedLotLotsCard from '~/components/consolidatedLotLotsCard/consolidatedLotLotsCard';
import ProductIngredientsCard from '~/components/productIngredientsCard/productIngredientsCard';
import TitleBar from '~/components/titleBar/titleBar';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import StartCompleteButton from './startCompleteButton';

export const getLotQuery = gql`
  query lot($id: Int!) {
    lot(id: $id) {
      id
      isConsolidated
      product {
        id
        name
        abv
        volume
      }
      wastage
      consolidatedLotId
      consolidatedLot {
        id
        reference
      }
      consolidatedLots {
        id
        reference
      }
      ingredients {
        id
        amount
        measurementType
        name
        type
      }
      currentTank {
        id
        name
      }
      reference
      notes
      status
      startDate
      isSample
      currentVolume
      volume
      permitNumber
      dutyPaid
      createdByUser {
        id
        firstName
        lastName
      }
      startedByUser {
        id
        firstName
        lastName
      }
      completedByUser {
        id
        firstName
        lastName
      }
      transfers {
        id
        name
        type
        tankType
        notes
        vesselDescription
        stepNumber
        transferDate
        status
        isConsolidated
        requiresDutyPaid
        completedAt
        shouldAutocomplete
        completedByUser {
          id
          firstName
          lastName
        }
        location {
          id
          name
        }
        tank {
          id
          name
        }
      }
    }
  }
`;

export class Lot extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Weird bug that I couldn't figure out - we call the `onCompleted` prop which, in most cases I've built,
      // updates state on the parent which causes a rerender of this child. In most cases this is fine but for
      // some reason in this components case the rerender would cause a refetch which would cause `onCompleted`
      // to fire a shitload of times causing a bug. So, this stops that. Weird, but it works
      return false;
    }

    return true;
  }

  renderTitleButtons = lot => {
    const lotId = this.props.match.params.lotId;
    return (
      <Fragment>
        <StartCompleteButton lot={lot} />
        <Link to={`/lots/${lotId}/edit`}>
          <Button color="primary">Edit</Button>
        </Link>
      </Fragment>
    );
  };

  getTitle = lot => {
    if (lot.isConsolidated) {
      return `${lot.reference} (consolidated)`;
    }
    return lot.reference;
  };

  render() {
    const { onCompleted, id } = this.props;
    return (
      <Query
        query={getLotQuery}
        notifyOnNetworkStatusChange
        variables={{ id }}
        onCompleted={onCompleted}
        fetchPolicy={'cache-and-network'}
      >
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { lot } = data;
          return (
            <Fragment>
              <URLParamBanner name="lot" />
              <TitleBar
                headerClassName="flex items-center"
                back={`/lots${lot.isConsolidated ? '/#consolidated' : ''}`}
                backText="Lots"
                title={this.getTitle(lot)}
                button={this.renderTitleButtons(lot)}
              />
              <div className="flex content">
                <div className="flex-2 mr4">
                  <LotDetailCard {...lot} className="mb4" />
                  <LotTransfersCard lotTransfers={lot.transfers} lot={lot} />
                  {!lot.isConsolidated && <ProductIngredientsCard ingredients={lot.ingredients} />}
                  {lot.isConsolidated && <ConsolidatedLotLotsCard lots={lot.consolidatedLots} />}
                </div>
                <div className="flex-1">
                  <LotSummaryCard {...lot} />
                  <NotesCard className="mt4" notes={lot.notes} />
                </div>
              </div>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(Lot);



// WEBPACK FOOTER //
// ./src/containers/lot/lot.jsx